import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconStop(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M13.6066 0.87868C13.044 0.316071 12.2809 3.63887e-07 11.4853 3.22578e-07L6.51469 6.45156e-08C5.71904 2.3207e-08 4.95598 0.316071 4.39337 0.87868L0.878649 4.3934C0.31604 4.95601 -3.01537e-05 5.71907 -3.0195e-05 6.51472L-3.04531e-05 11.4853C-3.04944e-05 12.2809 0.31604 13.044 0.87865 13.6066L4.39337 17.1213C4.95598 17.6839 5.71904 18 6.51469 18L11.4853 18C12.2809 18 13.044 17.6839 13.6066 17.1213L17.1213 13.6066C17.6839 13.044 18 12.2809 18 11.4853V6.51472C18 5.71907 17.6839 4.95601 17.1213 4.3934L13.6066 0.87868Z"
          fill="#D65B3C"
        />
        <path d="M5.46561 12.5356L12.5367 5.46458" stroke="white" strokeWidth="2" />
        <path d="M12.5365 12.5356L5.46543 5.46458" stroke="white" strokeWidth="2" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 0H18V18H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </SVGIcon>
  );
}
